<template>
  <div ref="tipBox" class="group-tip-element-wrapper">{{text}}</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'GroupTipElement',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  
  computed: {
    ...mapGetters([
      'currentMemberList',
      'contactsList',
    ]),
    text() {
      return this.getGroupTipContent(this.payload)
    }
  },
  methods: {
    getGroupTipContent(payload) {
      switch (payload.operationType) {
        case this.TIM.TYPES.GRP_TIP_MBR_JOIN:
          this.initMemberInfo(payload.userIDList,'加入群组');
          return `群成员：${payload.userIDList.join(',')}，加入群组`
        case this.TIM.TYPES.GRP_TIP_MBR_QUIT:
          this.initMemberInfo(payload.userIDList,'退出群组');
          return `群成员：${payload.userIDList.join(',')}，退出群组`
        case this.TIM.TYPES.GRP_TIP_MBR_KICKED_OUT:
          this.initMemberInfo(payload.userIDList,'被移出群组');
          return `群成员：${payload.userIDList.join(',')}，被${payload.operatorID}踢出群组`
          return `群成员：${payload.userIDList.join(',')}，被管理员踢出群组`
        case this.TIM.TYPES.GRP_TIP_MBR_SET_ADMIN:
          this.initMemberInfo(payload.userIDList,'成为管理员');
          return `群成员：${payload.userIDList.join(',')}，成为管理员`
        case this.TIM.TYPES.GRP_TIP_MBR_CANCELED_ADMIN:
          this.initMemberInfo(payload.userIDList,'被撤销管理员');
          return `群成员：${payload.userIDList.join(',')}，被撤销管理员`
        case this.TIM.TYPES.GRP_TIP_GRP_PROFILE_UPDATED:
          return '群资料修改'
        case this.TIM.TYPES.GRP_TIP_MBR_PROFILE_UPDATED:
          return '群成员资料修改'
        default:
          return '[群提示消息]'
      }
    },
    initMemberInfo(userIDList,tip) {
      let promise = tim.getUserProfile({
        userIDList: userIDList
      });
      let $this = this;
      promise.then(function(imResponse) {
        let memberName = [];
        imResponse.data.forEach(item=>{
          memberName.push(item.nick);
        });
        $this.$refs.tipBox.innerText = memberName.join('、') +" "+tip
      }).catch(function(imError) {
        console.warn('getUserProfile error:', imError);    
      });
    },
  }
}
</script>

<style scoped>
.group-tip-element-wrapper {
  background: #fff;
  padding: 4px 15px;
  border-radius: 3px;
  color: #a5b5c1;;
  font-size: 12px;
}
  
</style>
